export const getFeedview = state => state.feedviews.feedview;

export const getTmpFeedview = state => state.feedviews.tmpFeedview;

export default getFeedview;
